import localeDateInputOrder from '@/helpers/locale-date-input-order';



/**
 * Convert structured birthday data from the BE into the slash-separated
 * string the birthday input v-models. Order matches the device locale —
 * en-GB / en-AU get "DD/MM/YYYY", everyone else gets "MM/DD/YYYY".
 *
 * @param {object} birthday
 * @param {number} birthday.day
 * @param {number} birthday.month
 * @param {number} [birthday.year]
 * @returns {string}
 */
function formatBirthdayForInput({ day, month, year }) {
  const dd = String(day).padStart(2, '0');
  const mm = String(month).padStart(2, '0');
  const order = localeDateInputOrder();

  if (order === 'DMY') {
    return year ? `${dd}/${mm}/${year}` : `${dd}/${mm}`;
  }

  return year ? `${mm}/${dd}/${year}` : `${mm}/${dd}`;
}



export default formatBirthdayForInput;
